import { StyledTextInputRoot, InputLabelProps } from "./TextInput";
import React, { forwardRef } from "react";
import CurrencyInput from "react-currency-input-field";
import { IntlConfig } from "react-currency-input-field/dist/components/CurrencyInputProps";

export type MoneyInputProps = {
  name?: string;
  onChange: (value?: string, name?: string | undefined) => void;
  value?: number | string;
  className?: string;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
  size?: "small" | "large";
  isDisabled?: boolean;
  bare?: boolean;
  fullWidth?: boolean;
  intlConfig?: IntlConfig;
} & InputLabelProps;

export const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(
  (
    {
      value,
      onChange,
      size,
      className,
      error,
      label,
      isRequired,
      placeholder,
      isDisabled,
      bare = false,
      labelType = "normal",
      fullWidth = false,
      intlConfig = {
        locale: "en-US",
        currency: "USD",
      },
    },
    ref,
  ) => {
    return (
      <StyledTextInputRoot
        labelType={labelType}
        size={size}
        className={error ? `field-error ${className}` : className}
        error={error}
        bare={bare}
        fullWidth={fullWidth}
      >
        {label && labelType === "normal" ? (
          <label htmlFor={label}>
            {label} {isRequired && <span className="required">*</span>}
          </label>
        ) : undefined}
        <div className="input-container">
          <CurrencyInput
            ref={ref}
            name={label}
            placeholder={placeholder}
            value={value}
            onFocus={(e) => e.target.select()}
            onValueChange={(value, name) => onChange(value, name)}
            disabled={isDisabled}
            className={labelType === "floating" ? "floating-label-input" : ""}
            allowDecimals={true}
            intlConfig={intlConfig}
          />
          {labelType === "floating" ? (
            <label
              onClick={(e) => {
                const previousSibling = e.currentTarget
                  .previousSibling as HTMLInputElement;
                if (previousSibling && previousSibling.focus) {
                  previousSibling.focus();
                }
              }}
              htmlFor={label}
              className="floating-label label"
            >
              {label} {isRequired && <span className="required">*</span>}
            </label>
          ) : undefined}
        </div>
        <div className="error">{error}&nbsp;</div>
      </StyledTextInputRoot>
    );
  },
);

MoneyInput.displayName = "MoneyInput";
